<template>
  <div>
    <div id="pysakkilist_filter">
      <TableActionHeader @filterChange="(val) => {this.filter = val}" :newButton=false></TableActionHeader>
    </div>
        <b-table hover striped :items="listData" :fields="fields"
            :responsive="false"
            :small="true"
            primary-key="tunnus"
            ref="pysakkiList"
            selectable selection-mode="multi"
            @row-selected="onRowSelected"
            :filter="filter"
            :per-page="pagingPerPage"
            :current-page="currentPage"
            :filter-function="filterMethod"
            @filtered="onFiltered"
            >
            <template v-slot:cell(tunnus)="data">
               <span>{{ data.value }}</span>
            </template>
            <template v-slot:cell(nimi)="data">
                <span class="listNameText"><p class="listNameParag">{{ data.item.nimi }}</p></span>
            </template>
          </b-table>
        <div class="d-flex justify-content-center">
          <TablePagination :perPage="pagingPerPage" :totalRows="listLength" @pageChange="(p)=>{this.currentPage = p}"></TablePagination>
        </div>
  </div>
</template>

<script>
import timetable from '@/store/timetable/timetable'

export default {
  name: 'PysakkiList',
  props: {
   // msg: String
  },
  data: function() {
        return {
            fields: [ 
            {key:'tunnus',label:this.$t('pysakki_list.id'), sortable: true },
            {key:'sms' , label:this.$t('pysakki_list.short_id'), sortable: true },
            {key:"nimi",label:this.$t('pysakki_list.name'), sortable: true }
            ],
            currentPage: 1,
            selected: [],
            //listData: [],
            listLength: 0,
            pagingPerPage: 5,
            filter: null
        }
  },
  beforeCreate: function() {
    if (!this.$store.state.timetable) {
      this.$store.registerModule("timetable" , timetable);
    }
  },
  created: function() {
  },
  mounted: function() {
    if(!this.listData || this.listData.length === 0) {
       this.$store.dispatch('timetable/getPysakkiListData')
       //.then((data) => {this.listLength = data.length})
       .catch(function(){
       });
    } else {
         this.listLength = this.listData.length
    }
    this.deselectAll();
  },
  computed: {
    listData: function() {
      return this.$store.state.timetable.pysakit.list;
    },
    
  },
  watch: {
    listData: function( data ) {
      if( data ) {
        this.listLength = data.length
      } else {
        this.listLength = 0;
      }
      this.currentPage = 1
    }
  },
  methods: {
    onRowSelected(items) {
      this.selected = items
    },
    deselectAll() {
      this.$refs.pysakkiList.clearSelected();
      this.selected = [];
    },
    getSelectedList() {
      return JSON.parse(JSON.stringify(this.selected));
      //return Object.assign({}, this.selected);
    },
    filterMethod(item , filter ) {
      var filterLowerCase = filter.toLowerCase()
        return (item.nimi && item.nimi.toLowerCase().includes(filterLowerCase)) || 
          (item.tunnus && item.tunnus.toLowerCase().includes(filterLowerCase)) || 
          (item.sms && item.sms.toLowerCase().includes(filterLowerCase))
    },
    onFiltered( filteredItems ) {
      this.listLength = filteredItems.length
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
p {
  margin-bottom: 0.1rem;
}
p .listNameParag {
  margin-bottom: 0.1rem;
}
.listNameText {
  font-weight: bold;
}
.listLabelText {
  font-style: italic;
  padding-left: 1em;
}
</style>
